<template>
    <figure ref="figure">
        <svg v-if="isSimpleLadder" :width="width" :height="figureHeight">
            <rect :x="0" :y="0" :width="width" :height="figureHeight" />

            <circle
                v-for="i in (value.height - value.topPawl - value.bottomPawl) / value.pawlInterval + 1"
                :key="i"
                :cx="width / 2"
                :cy="((value.topPawl + (i - 1) * value.pawlInterval) / value.height) * figureHeight"
                :r="figureHeight / 200"
            />
        </svg>
        <svg v-else :width="width" :height="figureHeight">
            <rect :x="0" :y="0" :width="width" :height="figureHeight" />

            <circle
                v-for="i in (value.height - value.topPawl - value.bottomPawl) / value.pawlInterval + 1"
                :key="i"
                :cx="(width * 3) / 4 / 2"
                :cy="((value.topPawl + (i - 1) * value.pawlInterval) / value.height) * figureHeight"
                :r="figureHeight / 200"
            />
            <circle
                v-for="i in (value.height - value.topPawl - value.bottomPawl) / value.pawlInterval + 1"
                :key="i"
                :cx="(width * 3) / 4 / 2 + width / 4"
                :cy="((value.topPawl + (i - 1) * value.pawlInterval) / value.height) * figureHeight"
                :r="figureHeight / 200"
            />
        </svg>
    </figure>
</template>

<script>
export default {
    props: ["value"],
    data: () => ({
        figureWidth: 0,
        figureHeight: 0
    }),
    mounted() {
        const getFigureDimensions = () => {
            if (this.figureWidth !== this.$refs.figure.clientWidth) this.figureWidth = this.$refs.figure.clientWidth;
            if (this.figureHeight !== this.$refs.figure.clientHeight) this.figureHeight = this.$refs.figure.clientHeight;
        };
        this.intervalId = setInterval(getFigureDimensions, 100);
        setTimeout(getFigureDimensions, 0);
    },
    computed: {
        width() {
            return this.aspectRatio * this.figureHeight;
        },
        aspectRatio() {
            return this.value.width / this.value.height;
        },
        isSimpleLadder() {
            return this.value.type === 1;
        }
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    }
};
</script>

<style lang="scss" scoped>
figure {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 100%;
}

circle {
    fill: grey;
}

rect {
    fill: white;
    stroke: black;
}
</style>



// WEBPACK FOOTER //
// ladder-preview.vue?6fc0aae2